export enum PdfType {
  SUMMARY_SESSION,
  SIGNIFICANCE_TRACKER,
}
